import { removeDuplicates } from '../../helpers/_main.js'
export default {
    getBasketCount(state) {
        return state.user.cart.order_line_items.length
    },
    getBasket(state) {
        return state.user.cart.order_line_items
    },
    getWishlist(state) {
        return removeDuplicates(state.user.wish_list, 'sku_code')
    },
    getUserPaymentTerms(state) {
        return state.user.payment_terms
    },
    getUserCredit(state) {
        return { 
            credit_6: state.user.credit_6,
            credit_12: state.user.credit_12,
        }
    },
    getUser(state) {
        return state.user
    },
    getLinks(state) {
        return state.user.links
    }
}


// WEBPACK FOOTER //
// ./assets/js/vue/store/getters/usersGetters.js